import { z } from "zod";
import { foreignCountryNonEU, foreignCountryEU } from "../mydata";
import { greekVATNumber } from "./greek-vat-number.js";
import { vatCountriesEU } from "../vatnumbers";

export const recipientAddress = z.object({
  postalCode: z.string().min(1),
  city: z.string().min(1),
  number: z.number().int().positive().optional(),
  street: z.string().optional(),
});
export const branchNumber = z
  .number()
  .nonnegative()
  .int()
  .optional()
  .default(0);
export const recipientGR = z.object({
  country: z.literal("GR"),
  name: z.string().min(1),
  branch: branchNumber,
  vatNumber: greekVATNumber,
  address: z.object({
    postalCode: z.string().regex(/^\d{5}$/, `Μή έγκυρος Τ.Κ.`),
    city: z.string().optional(),
    number: z.number().int().positive().optional(),
    street: z.string().optional(),
  }),
  notes: z.string().optional(),
  doy: z.string()
});

export const recipientEU = z
  .object({
    name: z.string(),
    branch: branchNumber,
    address: recipientAddress,
    country: z.enum(foreignCountryEU),
    vatNumber: z.string(),
    notes: z.string().optional(),
    doy: z.undefined()
  })
  .refine(
    (input) => {
      const { regex } = vatCountriesEU[input.country];
      return typeof input.vatNumber === "string" && regex.test(input.vatNumber);
    },
    (val) => {
      const { examples } = vatCountriesEU[val.country];
      return {
        message: `Μη έγκυρος αριθμός φορολόγησης για ${
          val.country
        } (π.χ. ${examples.join(", ")})`,
        path: ["vatNumber"],
      };
    }
  );

export const recipientNonEU = z.object({
  name: z.string(),
  country: z.enum(foreignCountryNonEU),
  branch: branchNumber,
  vatNumber: z.string(),
  address: recipientAddress,
  notes: z.string().optional(),
  doy: z.undefined()
});
